import React, { useState } from 'react';
import ParticleEffectButton from "react-particle-effect-button";
import { skills } from "../../Data/skills";
import { Bounce } from 'react-reveal';
const Skills = () => {

    const [hide, setHide] = useState(false);
    return (
        <div>
        <h2 className="text-center text-3xl uppercase font-bold mb-5 ">
          Skills
        </h2>
        <div className="grid grid-cols-3 gap-4 ">
          {skills.map((skill, idx) => (
            <div
              onClick={() => setHide(!hide)}
              key={idx}
              className="btn text-white bg-teal-800 rounded border hover:bg-white hover:text-gray-900   glass   font-bold   text-md "
            >
              <Bounce right delay={idx * 100}>
                <ParticleEffectButton
                  color={`${hide ? "#FFDF00" : "#ffffff"} `}
                  hidden={hide}
                  duration={`${hide ? 500 : 300} `}
                  canvasPadding={100}
                  type={"rectangle"}
                  speed={-2}

                >
                  <span className="flex flex-col justify-center items-center">
                    {skill?.logo}
                    {skill?.name}
                  </span>
                </ParticleEffectButton>
              </Bounce>
            </div>
          ))}
        </div>
      </div>
    );
};

export default Skills;